import Swal from "sweetalert2"
import Router from '@/routes'
import initMMIOaxios from "@/utils/axios"

export default {

	async getCallToAction({ commit, dispatch }, prompt){
        const axios = await initMMIOaxios()
        return await axios.post("/apis_integrations/get_call_to_action", {prompt})
                    .then( resp => {
                        __console.log( "getCallToAction -> ", resp.data)
                        if(resp.data.error){return resp.data.error}
                        return (resp?.data?.choices?.[0]?.text || "").trim()
                    }).catch( e => __console.log(e))
	},

	async autoGenerateContent({ commit, dispatch }, prompt){
        let data = {
            prompt,
            type: prompt.type
        }
        const axios = await initMMIOaxios()
        return await axios.post("/apis_integrations/auto_generate_content", data)
                    .then( resp => {
                        __console.log( "autoGenerateContent -> ", resp.data)
                        if(resp.data.error){
                            Swal.fire("Unsafe Content Detected", "Your content has been filrtered out because it contains unsafe content. Please refrain from creating unsafe content or your account will be banned forever.", "error")
                            return '';
                        }else if(resp?.data?.content_label == '1'){
                            triggerContentWarning((resp?.data?.choices?.[0]?.text || "").trim())
                            return "";
                        }
                        return (resp?.data?.choices?.[0]?.text || "").trim()
                    }).catch( e => __console.log(e))
	},
    
	async generateProductPromotionCopy({ commit, dispatch }, product_name){
        const axios = await initMMIOaxios()
        return await axios.post("/apis_integrations/generate_product_promotion_copy", {product_name})
                    .then( resp => {
                        __console.log( "generateProductPromotionCopy -> ", resp.data)
                        if(resp.data.error){
                            Swal.fire("Unsafe Content Detected", "Your content has been filrtered out because it contains unsafe content. Please refrain from creating unsafe content or your account will be banned forever.", "error")
                            return '';
                        }else if(resp?.data?.content_label == '1'){
                            triggerContentWarning((resp?.data?.choices?.[0]?.text || "").trim())
                            return '';
                        }
                        return (resp?.data?.choices?.[0]?.text || "").trim()
                    }).catch( e => __console.log(e))
	},

}

function triggerContentWarning(content){
    Swal.fire({
        title: "Sensitive Content Detected",
        html: `
            <p class="mb-5">Your auto-generated text may contain sensitive content.</p>
            <p class="mb-5"><mark>${content}</mark></p>
            </br>
            <p>If this is a misclassification, please report it by clicking the "Report Issue" button.</p>
        `,
        icon: "warning",
        confirmButtonText: "REPORT ISSUE",
        showCancelButton: true,
        customClass: {
            popup: 'sensitive-content-warning',
        },                                
    }).then( value => {
        if(value.value){
            Router.push({name: 'Support Tickets'})
        }
    })
}